import { List } from "antd";
import "./custom.css";
import { CenterSpinnerAtom } from "~/components/Atoms/CenterSpinnerAtom/CenterSpinnerAtom";
import {
  VoteCard,
  type VoteDetail,
} from "~/components/Components/VoteCard/VoteCard";

type Props = {
  votes: VoteDetail[];
  isLoading: boolean;
  hasMoreData: boolean;
};

export const VoteCardListModule = (props: Props) => {
  return (
    <>
      {props.isLoading ? (
        <CenterSpinnerAtom type="MORE" />
      ) : (
        <>
          <List
            locale={{
              emptyText: (
                <div className="flex h-[calc(100vh-120px)] items-center justify-center">
                  <div>No Votes</div>
                </div>
              ),
            }}
            className="ant-list-items-no-gap"
            itemLayout="vertical"
            dataSource={props.votes}
            renderItem={(vote) => (
              <List.Item key={vote.id}>
                <VoteCard vote={vote} type={"LIST"} />
              </List.Item>
            )}
          />
          {props.hasMoreData ? (
            <CenterSpinnerAtom type="MORE" />
          ) : (
            <div className="h-[100px] bg-[#f5f5f5]"></div>
          )}
        </>
      )}
    </>
  );
};
